import {
  createTeamData,
  getTeamDataTemplate,
  getTeamData,
  getTeamUserData,
  addTicketCount,
  deleteTeamTicket,
  deleteTicketUser,
  getTeamUserDataTemplate,
  createTeamUserData,
  getTeamByID,
  editTeam,
  getTicketUserByID,
  editTicketUser,
  createUserAvailability,
  updateUserAvailability,
  getUserAvailability,
  getUserAvailabilityById,
  getUserAvailabilityByUserId,
  getShiftMapping,
  getShiftMappingById,
  getShiftMappingData,
  getShiftMappingId,
  createShiftMappingTemplate,
  editshiftMapping,
  deleteShiftMapping,
  getShiftMappingByTeamAndShift,
  getLeaveByUserId,
  deleteUserLeave,
} from "@/http/setup/teams";

export default {
  namespaced: true,
  state: {
    createTeamResp: null,
    teamTemplate: {},
    teamList: [],
    shiftList: [],
    shiftListById: [],
    teamUserList: [],
    teamuserTemplate: {},
    shiftMappingTemplate: {},
    createTeamUserResp: null,
    teamById: {},
    teamUserById: {},
    shiftListByTeam: {},

    allAvailableUsers: [],
    availableUserData: {},
    availibilityListByUserId: [],
    leaveByUserId: [],
  },
  actions: {
    async createTeamAction({ commit }, data) {
      const resp = await createTeamData(data);
      commit("CREATE_TEAM_RESP", resp.data.resourceId);
      return resp;
    },
    async setTeamDataTemplate({ commit }) {
      const resp = await getTeamDataTemplate();
      commit("SET_CREATE_TEAM_TEMPLATE", resp.data);
      return resp;
    },
    async setShiftData({ commit }) {
      const response = await getShiftMapping();
      commit("SET_SHIFT_LIST_DATA", response.data);
      return response;
    },
    async setShiftDataById({ commit }) {
      const response = await getShiftMappingById();
      commit("SET_SHIFT_LIST_DATA_BY_ID", response.data);
      return response;
    },
    async setTeamData({ commit }) {
      const response = await getTeamData();
      commit("SET_TEAM_LIST_DATA", response.data.pageItems);
      return response;
    },
    async setTeamUserData({ commit }) {
      const response = await getTeamUserData();
      commit("SET_TEAMUSER_LIST_DATA", response.data.pageItems);
      return response;
    },
    async deleteTeamAction({ commit }, id) {
      await deleteTeamTicket(id);
    },
    async deleteShiftMappingAction({ commit }, id) {
      await deleteShiftMapping(id);
    },
    async deleteTeamUserAction({ commit }, id) {
      await deleteTicketUser(id);
    },

    async setTicketDataTemplate({ commit }) {
      const responce = await getTeamUserDataTemplate();
      commit("SET_TEAMUSER_TEMPLATE", responce.data);
      return responce;
    },
    async setShiftMappingData({ commit }) {
      const responce = await getShiftMappingData();
      commit("SET_SHIFT_MAPPING_TEMPLATE", responce.data);
      return responce;
    },
    async getShiftMappingIdAction({ commit }, id) {
      const responce = await getShiftMappingId(id);
      return responce;
    },
    async getShiftMappingByTeamAndShiftAction({ commit }, { teamId, shiftId }) {
      const responce = await getShiftMappingByTeamAndShift(teamId, shiftId);
      commit("SET_SHIFT_BY_TEAM_SHIFT", responce.data);
      return responce;
    },
    async createTeamUserAction({ commit }, data) {
      const resp = await createTeamUserData(data);
      commit("CREATE_TEAMUSER_RESP", resp.data.resourceId);
      return resp;
    },
    async setTeamById({ commit }, id) {
      const responce = await getTeamByID(id);
      commit("SET_TEAM_BY_ID", responce.data);
      return responce;
    },
    async editTeamAction({ commit }, data) {
      const resp = await editTeam(data.id, data.data);
      return resp;
    },
    async updateTicketCount({ commit }, data) {
      const resp = await addTicketCount(data.id,{ maxActiveTicketCount: data.maxActiveTicketCount });
      return resp;
    },
    async editshiftMappingAction({ commit }, data) {
      const resp = await editshiftMapping(data);
      return resp;
    },
    async setTicketUserById({ commit }, id) {
      const resp = await getTicketUserByID(id);
      commit("SET_TICKET_USER_BY_ID", resp.data);
      return resp;
    },
    async editTeamUserAction(_, data) {
      const resp = await editTicketUser(data.id, data.data);
      return resp;
    },
    async createUserAvailabilityAction(_, data) {
      const resp = await createUserAvailability(data);
      return resp;
    },
    async createShiftMappingTemplateAction(_, data) {
      const resp = await createShiftMappingTemplate(data);
      return resp;
    },
    async updateUserAvailabilityAction(_, data) {
      const resp = await updateUserAvailability(data.id, data.data);
      return resp;
    },
    async deleteUserLeaveAction({ commit }, id) {
          try {
            let res = await deleteUserLeave(id);
            commit("RESET_USER_LEAVE_LIST", id);
            return res;
          } catch (error) {
            throw Error(
              error.message.errors[0].defaultUserMessage ||
                `Api failed with status code: ${error.message.httpStatusCode}`
            );
          }
        },
    async getUserAvailabilityAction({ commit }) {
      const resp = await getUserAvailability();
      commit("SET_ALL_AVAILABLE_USERS", resp.data);
      return resp;
    },
    async getUserAvailabilityByIdAction({ commit }, id) {
      const resp = await getUserAvailabilityById(id);
      commit("SET_AVAILABLE_USER_DATA", resp.data);
      return resp;
    },
    async getUserAvailabilityByUserIdAction({ commit }, id) {
      const resp = await getUserAvailabilityByUserId(id);
      commit("SET_AVAILABLE_LIST_BY_USER", resp.data);
      return resp;
    },
    async getLeaveByUserIdAction({ commit }, id) {
      const resp = await getLeaveByUserId(id);
      commit("SET_LEAVE_BY_USER_ID", resp.data);
      return resp;
    },
  },
  mutations: {
    ["CREATE_TEAM_RESP"](state, payload) {
      Object.assign(state, { createTeamResp: payload });
    },
    ["SET_CREATE_TEAM_TEMPLATE"](state, payload) {
      Object.assign(state, { teamTemplate: payload });
    },
    ["SET_SHIFT_LIST_DATA_BY_ID"](state, payload) {
      Object.assign(state, { shiftListById: payload });
    },
    ["SET_SHIFT_BY_TEAM_SHIFT"](state, payload) {
      Object.assign(state, { shiftListByTeam: payload });
    },
    ["SET_SHIFT_LIST_DATA"](state, payload) {
      Object.assign(state, { shiftList: payload });
    },
    ["SET_TEAM_LIST_DATA"](state, payload) {
      Object.assign(state, { teamList: payload });
    },
    ["SET_TEAMUSER_LIST_DATA"](state, payload) {
      Object.assign(state, { teamUserList: payload });
    },
    ["SET_TEAMUSER_TEMPLATE"](state, payload) {
      Object.assign(state, { teamuserTemplate: payload });
    },
    ["SET_SHIFT_MAPPING_TEMPLATE"](state, payload) {
      Object.assign(state, { shiftMappingTemplate: payload });
    },
    ["CREATE_TEAMUSER_RESP"](state, payload) {
      Object.assign(state, { createTeamUserResp: payload });
    },
    ["SET_TEAM_BY_ID"](state, payload) {
      Object.assign(state, { teamById: payload });
    },
    ["SET_TICKET_USER_BY_ID"](state, payload) {
      Object.assign(state, { teamUserById: payload });
    },
    ["SET_ALL_AVAILABLE_USERS"](state, payload) {
      Object.assign(state, { allAvailableUsers: payload });
    },
    ["SET_AVAILABLE_USER_DATA"](state, payload) {
      Object.assign(state, { availableUserData: payload });
    },
    ["SET_AVAILABLE_LIST_BY_USER"](state, payload) {
      Object.assign(state, { availibilityListByUserId: payload });
    },
    ["SET_LEAVE_BY_USER_ID"](state, payload) {
      Object.assign(state, { leaveByUserId: payload });
    },
    RESET_USER_LEAVE_LIST(state, id) {
      state.allAvailableUsers = state.allAvailableUsers.filter((el) => el.id !== id);
    },
  },
};
